import { Diagram } from 'gojs';

export const highlightNodes = (nodeKeys: string[] = [], diagram: Diagram): void => {
  try {
    if (nodeKeys.length < 1) {
      return;
    }

    const results = diagram.findNodesByExample({
      key: (k: string) => nodeKeys.includes(k),
    });

    const oldSkips = diagram.skipsUndoManager;
    diagram.skipsUndoManager = true;

    diagram.highlightCollection(results);
    const firstNode = results.first();
    if (results.count > 0 && firstNode) {
      diagram.selectCollection([firstNode]);
      diagram.commandHandler.scrollToPart(firstNode);
      diagram.scale = 1;
    }

    diagram.skipsUndoManager = oldSkips;
  } catch (error) {
    console.log(error);
    diagram.clearHighlighteds();
  }
};
